import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import Box from '../../../elements/Box';
import Row from '../../../elements/Row';
import Col from '../../../elements/Col';

const PropertyAlert = (props) => {
  const { row } = props;
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  return (
    <Row {...row}>
      <Col textAlign="center">
        <Box paddingHeight="5" className={className} style={style}></Box>
      </Col>
    </Row>
  );
};
PropertyAlert.propTypes = {
  row: PropTypes.objectOf(PropTypes.any)
};

PropertyAlert.defaultProps = {
  row: {}
};

PropertyAlert.componentName = 'PropertyAlert';
export default PropertyAlert;
